module.exports = __webpack_public_path__ + "static/12-007f5da36bf47a4dbcd1e85700e5c0cc.png";